export default "DYNAMIC_PACKAGE_MODULE";
